import React from "react";

function ActiveStatus({ value }) {
  const PrefixElement = () => {
    if (value) {
      return (
        <div className="w-3 h-3 rounded-full bg-[#0B662C] flex shrink-0"></div>
      );
    } else {
      return (
        <div className="w-3 h-3 rounded-full bg-[#B81F25] flex shrink-0"></div>
      );
    }
  };
  return (
    <div className="flex gap-2 items-center">
      <PrefixElement />
      <span className="text-sm">{value ? "Active" : "Inactive"}</span>
    </div>
  );
}

export default ActiveStatus;
